export default __webpack_public_path__ + "static/media/comment.52b1359b.svg";